import { FlexRow, MaterialIcon, StyledButton, StyledSearchBar, useModal } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { memo, useEffect, useMemo } from 'react';
import { DRIVERS_STATUS } from '../../../constants/drivers';
import { useStyles } from '../../../hooks/useStyles';
import { StyledTooltip } from '../../ui/StyledTooltip';
import { useFleetDrivers } from '../hooks/useFleetDrivers';
import FleetDriverModal from './driver/FleetDriverModal';

function FleetDriversFiltersBar() {
  const { css, theme } = useStyles();
  const { closeModal, openModal, showModal } = useModal();
  const { onReload, search, filters, onChangeSearch, resetAllFilters, onChangeFilter } = useFleetDrivers();

  useEffect(() => {
    return () => {
      resetAllFilters();
    };
  }, []);

  const driversStatusOptions = useMemo(() => {
    return [
      {
        id: undefined,
        label: 'Todos',
      },
      ...Object.keys(DRIVERS_STATUS).map((status) => ({ id: status, label: DRIVERS_STATUS[status] })),
    ];
  }, []);

  return (
    <FlexRow
      classNames={css({ alignItems: 'center' })}
      gap={theme.sizing.scale100}
    >
      <FlexRow
        classNames={css({ flex: '1', alignItems: 'center' })}
        gap={theme.sizing.scale300}
      >
        <span className={css({ flexGrow: '0.5' })}>
          <StyledSearchBar
            name="fleet-asset-search"
            value={search}
            onChange={onChangeSearch}
            clearable
            noMargin
          />
        </span>
        {/* TODO: uncomment when filters are available via api => <InlineSelect
          label="Mostrar:"
          options={driversStatusOptions}
          value={[{ id: filters.status }]}
          onChange={({ option }) => onChangeFilter('status', option?.id)}
        /> */}
      </FlexRow>
      <StyledTooltip
        content="Recargar tabla"
        showArrow={false}
      >
        <Button
          size="compact"
          shape="square"
          onClick={onReload}
          kind="tertiary"
        >
          <MaterialIcon name="refresh" />
        </Button>
      </StyledTooltip>
      <StyledButton
        onClick={openModal}
        startEnhancer={
          <MaterialIcon
            name="add"
            size={theme.sizing.scale600}
            color={theme.colors.contentInversePrimary}
          />
        }
      >
        Nuevo conductor
      </StyledButton>
      <FleetDriverModal
        isOpen={showModal}
        onClose={(update) => {
          if (update) onReload();
          closeModal();
        }}
      />
    </FlexRow>
  );
}

export default memo(FleetDriversFiltersBar);
